import classNames from 'classnames';
import { HTMLAttributes } from 'react';

export interface BreadcrumbsProps {
  className?: string;
}

function BreadcrumbsRoot({ children, className }: React.PropsWithChildren<BreadcrumbsProps>) {
  return <ol className={classNames('flex list-none m-0 p-0 items-center flex-wrap', className)}>{children}</ol>;
}

export interface BreadcrumbsLinkProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: HTMLAttributes<HTMLButtonElement>['onClick'];
}

export function Link({ children, className, onClick }: React.PropsWithChildren<BreadcrumbsLinkProps>) {
  return (
    <li
      className={classNames(
        'flex items-center flex-nowrap whitespace-nowrap',
        `after:content-['›']`,
        'after:flex after:mx-2 after:text-xl after:self-center after:leading-none after:-mt-[3px] after:whitespace-nowrap after:text-zinc-300 after:dark:text-gray-600 after:font-regular',
        'last-of-type:after:content-none',
        className,
      )}
    >
      <button
        onClick={onClick}
        disabled={typeof onClick !== 'function'}
        className={classNames(
          'inline-flex font-semibold uppercase rounded leading-normal text-xs tracking-wide',
          'text-cyan-500 hover:text-cyan-400 dark:text-cyan-400 dark:hover:text-cyan-300 hover:underline disabled:no-underline disabled:text-disabled dark:disabled:text-secondary',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 dark:focus-visible:ring-offset-gray-800',
        )}
      >
        {children}
      </button>
    </li>
  );
}

export const Breadcrumbs = Object.assign(BreadcrumbsRoot, { Link });

export default Breadcrumbs;
